<ng-container *ngIf="surveyViewerService.activeSurvey$ | async">
  <div data-testId="openForm" *ngIf="questionFormControl">
    <mat-form-field
      [color]="'primary'" class="w-full" data-testId="open">
                <textarea
                  appUpdateOnBlur
                  [errorStateMatcher]="errorMatcher" class="h-24" matInput
                  [formControl]="$any(questionFormControl)">
                  </textarea>
      <mat-error>
        {{'Champ obligatoire'|transloco}}.
      </mat-error>
    </mat-form-field>
  </div>
</ng-container>
